import { getConciliationAmountLimit } from '../../../../../../utils/conciliationAmountLimit'
let readSequence = 0

// Shared by the visible table and the automatic creation flow.
export const loadBankLinkageRows = async ({ api, businessId, libroId, from, to, payload, montoTotal, requestOptions }) => {
  const date = String(payload?.fecha || '').slice(0, 10)
  const query = {
    businessId,
    idLibro: libroId,
    from: date && date < from ? date : from,
    to: date && date > to ? date : to,
    amountFrom: 1,
    amountTo: getConciliationAmountLimit(Math.max(Math.abs(Number(montoTotal) || 0), Math.abs(Number(payload?.monto) || 0))),
    limit: 10000
  }
  const result = []
  const seen = new Set()
  let received = 0
  const deadline = Date.now() + (requestOptions?.timeout ?? 30000)
  for (let page = 0; page < 100; page++) {
    if (Date.now() >= deadline) break
    const response = await api.getListaParaVincular({ ...query, page }, {
      ...requestOptions,
      timeout: Math.max(1, deadline - Date.now()),
      params: { _refresh: `${Date.now()}-${++readSequence}` }
    })
    const rows = response?.data?.libros ?? response?.data
    if (!Array.isArray(rows)) {
      const failure = new Error('La respuesta de movimientos no contiene una lista válida.')
      failure.code = 'INVALID_LINKAGE_RESPONSE'
      throw failure
    }
    let added = 0
    for (const row of rows) {
      const key = String(row.idPrincipal ?? row.id)
      if (seen.has(key)) continue
      seen.add(key)
      result.push({ ...row, id: row.id ?? row.idPrincipal })
      added++
    }
    received += rows.length
    const count = Number(response?.data?.count)
    if (rows.length && !added) break
    if (!Number.isFinite(count) || received >= count) return result
    // A repeated or empty page cannot complete this snapshot. Do not create a
    // linkage against an incomplete baseline or keep requesting page zero.
    if (!added) break
  }
  const failure = new Error('No se pudo obtener la lista completa de movimientos del banco.')
  failure.code = 'INCOMPLETE_LINKAGE_RESPONSE'
  throw failure
}
